import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import * as Yup from 'yup'

import Table from '../../../../components/Table'
import Button from '../../../../components/Button'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, handleChangeClasses, selectedClasses }) {

  const dispatch = useDispatch()

  const { groupsEnd, } = useSelector(state => state.groups)

  const [selected, setSelected] = useState(null)

  const renderLi = (data) => {
    const { name, gid } = data
    return (
      <tr>
        <td
          onClick={() => handleChangeClasses(data)}
          style={{ backgroundColor: selectedClasses?.find(el => (el.gid == gid)) ? '#3689FF' : '' }}
        >
          {name}
        </td>
      </tr>
    )
  }


  const handleChange = (e) => {
    setSelected(
      { [e.target.name]: e.target.value }
    )
  }

  const handleSubmit = () => {
  }
  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>Классы</th>
                </tr>
              </thead>
              <tbody>
                {groupsEnd?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
        <div className={styles.inputsRow}>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Сохранить</Button>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Отменить</Button>
        </div>
      </>
    </Modal>

  )
}
